<template>
    <div id="intro" class="bg-white overflow-hidden position-relative width-100">
        <div class="container-fluid no-padding">
            <div class="row no-padding-rl xs-padding-6 padding-4">
                <div class="col-md-12 text-center">
                    <span class="display-block font-family-alt letter-spacing-1 text-gray-dark-2 text-medium text-uppercase">{{ intro }}</span>
                    <span class="display-block font-family-alt font-weight-700 letter-spacing-2 margin-1 no-margin-bottom text-gray-dark-2 text-uppercase xs-text-extra-large title-large">Du kommer til at opleve:</span>
                </div>
            </div>
            <div class="row">
                <div class="features-box col-md-4 no-padding text-center">
                    <div class="bg-cover bg-overlay-black-4 overflow-hidden position-relative" :style="'background-image: url(' + firstPicture + ')'">
                        <div class="height-100 position-absolute position-top position-left width-100">
                            <div class="display-table height-100 width-100">
                                <div class="display-table-cell text-center vertical-align-middle">
                                    <span class="display-block font-family-alt letter-spacing-2 text-medium text-uppercase text-white">{{ firstText }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="features-box col-md-4 no-padding text-center">
                    <div class="bg-cover bg-overlay-black-4 overflow-hidden position-relative" :style="'background-image: url(' + secondPicture + ')'">
                        <div class="height-100 position-absolute position-top position-left width-100">
                            <div class="display-table height-100 width-100">
                                <div class="display-table-cell text-center vertical-align-middle">
                                    <span class="display-block font-family-alt letter-spacing-2 text-medium text-uppercase text-white">{{ secondText }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="features-box col-md-4 no-padding text-center">
                    <div class="bg-cover bg-overlay-black-4 overflow-hidden position-relative" :style="'background-image: url(' + thirdPicture + ')'">
                        <div class="height-100 position-absolute position-top position-left width-100">
                            <div class="display-table height-100 width-100">
                                <div class="display-table-cell text-center vertical-align-middle">
                                    <span class="display-block font-family-alt letter-spacing-2 text-medium text-uppercase text-white">{{ thirdText }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            intro: {
                type: String,
                required: true
            },
            firstText: {
                type: String,
                required: true
            },
            firstPicture: {
                type: String,
                required: true
            },
            secondText: {
                type: String,
                required: true
            },
            secondPicture: {
                type: String,
                required: true
            },
            thirdText: {
                type: String,
                required: true
            },
            thirdPicture: {
                type: String,
                required: true
            }
        }
    }
</script>



// WEBPACK FOOTER //
// boxes.vue?6320075c